/* eslint-disable prettier/prettier */
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import {
  Investments,
  HelpIcon,
  InvestmentsPageTitle,
  SubtitleContainer,
  PageSubtitle,
  TooltipText,
  MainContainer,
  Container,
  StyledTooltips,
  SearchContainer,
  PreFooter,
  LoaderContainer
} from "./Styles";
import LoaderSVG from "../../components/LoaderSVG/LoaderSVG";
import MoldalActions from "../../redux/reducers/modal.reducer";
import MyBalance from "../../components/MyBalance/MyBalance";
import myBalanceActions from "../../redux/reducers/myBalance.reducer";
import InvestmentActions from "../../redux/reducers/investment.reducer";
import InvestListAccordion from "../../components/InvestListAccordion/InvestListAccordion";
import InvestFilterDetail from "../../components/InvestFilterDetail/InvestFilterDetail";
import InvestmentsPaginator from "../../components/InvestmentsPaginator/InvestmentsPaginator";
import WithoutInvestments from "components/WithoutInvestments/WithoutInvestments";
import filterInvest from "../../lib/models/filterInvest.mode";
import theme from "styles/LightTheme";
import "./InvestmentList.scss";

export const InvestmentList = () => {
  const { t } = useTranslation();
  const myBalance = useSelector(({ balance }) => balance);
  const [numberPage, setNumberPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [valueSelected, setValueSelected] = useState(1);
  const [nameFilter, setNameFilter] = useState("");
  const [businessLineFilter, setBusinessLineFilter] = useState(999);
  const [investmentStateFilter, setInvestmentStateFilter] = useState("");
  const [paymentStateFilter, setPaymentStateFilter] = useState("");
  const [campaignStateFilter, setcampaignStateFilter] = useState(
    filterInvest.campaignState.active
  );
  const [isFilterBy, setisFilterBy] = useState(true);
  const [userIp, setUserIp] = useState("");
  const [showInvestments, setShowInvestments] = useState(true);
  const { investmentsList } = useSelector(({ investment }) => investment);
  const isLoading = useSelector(({ investment }) => investment.isLoading);
  const hasInvestments = useSelector(
    ({ investment }) => investment.hasInvestments
  );
  const userInfo = useSelector(({ user }) => user.userInfo.user);
  const dispatch = useDispatch();

  const handleShowInvestments = () => {
    setShowInvestments(true);
    setTimeout(() => {
      const section = document.getElementById("investment-list-section");
      if (section) {
        const top =
          section.getBoundingClientRect().top + window.pageYOffset - 120;
        window.scrollTo({ top, behavior: "smooth" });
      }
    }, 100);
  };

  const modalGeneral = {
    clearBlur: true,
    css: {
      backgroundColor: theme.transparentMartinique
    }
  };

  useEffect(() => {
    const fetchIp = async () => {
      let res = await fetch("https://api.ipify.org?format=json", { method: "GET", headers: {} })
      let ip = await res.json();
      setUserIp(ip.ip);
    }
    fetchIp()
  }, []);

  useEffect(() => {
    dispatch(InvestmentActions.startHasInvestmentsFlow());
  }, []);

  useEffect(() => {
    dispatch(myBalanceActions.startBalanceFlow());
  }, []);

  useEffect(() => {
    dispatch(InvestmentActions.resetInvestmentsListCache());
  }, []);

  useEffect(() => {
    dispatch(
      InvestmentActions.startInvestmentsListFlowMs({
        page: numberPage,
        pageSize: pageSize,
        name: nameFilter,
        businessLine: businessLineFilter,
        investmentState: investmentStateFilter,
        campaignState: campaignStateFilter,
        paymentState: paymentStateFilter,
        isFilter: nameFilter !== "" || isFilterBy
      })
    );
  }, [numberPage, pageSize, nameFilter, businessLineFilter, investmentStateFilter, campaignStateFilter, paymentStateFilter]);

  const downloadFile = () => {
    dispatch(
      MoldalActions.setConditionalModalState(true, "ModalLoadingCertificate", {
        ...modalGeneral,
        description: t("searchInvestDetail.download")
      })
    );
    dispatch(
      InvestmentActions.startInvestmentsFile({
        name: "",
        businessLine: 999,
        investmentState: "",
        campaignState: "",
        paymentState: "",
        isFilter: false,
        userId: userInfo.id,
        userEmail: userInfo.email,
        userIp
      })
    );
  };

  return (
    <MainContainer>
      <MyBalance
        availableMoney={myBalance.availableMoney}
        availableMoneyExchange={myBalance.availableMoneyExchange}
        investments={myBalance.investments}
        investmentsExchange={myBalance.investmentsExchange}
        generalBalance={myBalance.generalBalance}
        equity={myBalance.equity}
        shares={myBalance.shares}
        convertibleNote={myBalance.convertibleNote}
        debt={myBalance.debt}
        onShowInvestments={handleShowInvestments}
      />
      {showInvestments && (
      <Container margins={{ bottom: "64px" }}>
        <InvestmentsPageTitle id="investment-list-section">
          {t("investment.investmentsList.title")}
        </InvestmentsPageTitle>
        <SubtitleContainer>
          <div className="download_component_desk">
            <div className="container_download_component">
              <PageSubtitle>
                {t("investment.investmentsList.subtitle")}
                {t("investment.investmentsList.subtitle2")}
              </PageSubtitle>
            </div>
            <div className="download_component">
              <div className="download_component__container">
                <button onClick={downloadFile} id="button_download_investment" disabled={!hasInvestments}>
                  {t("downloadFile.buttonName")}
                  <span className="download_component__container__icon"></span>
                </button>
              </div>
            </div>
          </div>
        </SubtitleContainer>


        <SearchContainer >
          <InvestFilterDetail
            setNameFilter={setNameFilter}
            setNumberPage={setNumberPage}
            setValueSelected={setValueSelected}
            setPageSize={setPageSize}
            setBusinessLineFilter={setBusinessLineFilter}
            setInvestmentStateFilter={setInvestmentStateFilter}
            setcampaignStateFilter={setcampaignStateFilter}
            setPaymentStateFilter={setPaymentStateFilter}
            setisFilterBy={setisFilterBy}
            isDisabled={investmentsList.data.length == 0 && (nameFilter == "" && !isFilterBy)}
            isFilterByDisabled={investmentsList.data.length == 0 && (nameFilter == "" && !isFilterBy)}
          />
        </SearchContainer>
        {isLoading ? (
          <LoaderContainer data-testid="investment-list-loader">
            <LoaderSVG />
          </LoaderContainer>
        ) : investmentsList.data.length === 0 && (nameFilter === "" && !isFilterBy) ? (
          <WithoutInvestments isPig={true} />
        ) : investmentsList.data.length === 0 && investmentStateFilter === "active" ? (
          <WithoutInvestments customMessage="Aún no cuentas con inversiones activas" />
        ) : investmentsList.data.length === 0 && investmentStateFilter === "mora" ? (
          <WithoutInvestments customMessage="Aún no cuentas con inversiones en mora" />
        ) : investmentsList.data.length === 0 && campaignStateFilter === filterInvest.campaignState.close ? (
          <WithoutInvestments customMessage="Aún no cuentas con inversiones finalizadas" />
        ) : investmentsList.data.length === 0 && (nameFilter !== "" || isFilterBy) ? (
          <WithoutInvestments isPig={true} />
        ) : (
          <Investments>
            {investmentsList.data.length > 0 &&
              investmentsList.data.map((item, index) => {
                item.firstElement = index === 0 ? true : false;
                return (
                  <>
                    {
                      <InvestListAccordion
                        key={String(item.id)}
                        investmentData={item}
                      />
                    }
                  </>
                );
              })}
          </Investments>
        )}
        <InvestmentsPaginator
          paginatorData={investmentsList.paginationParams}
          setNumberPage={setNumberPage}
          setPageSize={setPageSize}
          valueSelected={valueSelected}
          setValueSelected={setValueSelected}
          isDisabled={investmentsList.data.length == 0 && (nameFilter == "" || isFilterBy)} />
        <PreFooter />
      </Container>
      )}
    </MainContainer>
  );
};
